// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    display: inline-block;
    padding: 10px 20px;
    margin-top: 20px;
    background-color: #007bff;
    color: white;
    text-decoration: none;
    border-radius: 4px;
}

.button:hover {
    background-color: #0056b3;
}

.button-yellow-md {
    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;
    background: var(--Gradient-Gradient-Yellow, linear-gradient(180deg, #FFE08B 49%, #F9C32F 100%));
    display: inline-flex;
    height: 72px;
    padding: var(--Font-Size-Button-ButtonMd, 20px) var(--Space-Padding-Box-Padding-Button, 32px);
    justify-content: center;
    align-items: center;
    gap: var(--Font-Size-Button-ButtonMd, 20px);
    flex-shrink: 0;
    color: var(--Color-Brand-Text-Default, #0B1547) !important;
    font-size: var(--Font-Size-Button-ButtonMd, 20px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    transition: background 1s ease, color 0.3s ease, transform 0.2s ease;
    border: none !important;
    font-family: var(--Font-Family-All-purpose, Poppins);
}

.button-yellow-sm-500 {
    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;
    background: var(--Gradient-Gradient-Yellow, linear-gradient(180deg, #FFE08B 49%, #F9C32F 100%));
    color: var(--Color-Brand-Text-Default, #0B1547) !important;
    font-size: var(--Font-Size-Button-ButtonMd, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border: none !important;
    font-family: var(--Font-Family-All-purpose, Poppins);
}

.button-yellow-md:hover, .button-yellow-sm-500:hover {
    background: var(--Color-Brand-Surface-Yellow, #F9C32F) !important;
    color: var(--Color-Brand-Text-Default, #0B1547) !important;
}

.button-empty-sm-500 {
    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;
    border: 2px solid var(--Color-Brand-Border-Electric-Blue, #0027F9);
    color: var(--Color-Brand-Text-Default, #0027F9) !important;
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Small-Nav, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
}

.button-empty-sm-500:hover {
    background: #0027F9 !important;
    color: #fff !important;
}

.button-empty-md {
    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;
    border: 2px solid var(--Color-Brand-Border-Electric-Blue, #0027F9);
    color: #0027F9 !important;
    height: 72px;
    padding: 20px var(--Space-Padding-Box-Padding-Button, 32px);
    justify-content: center;
    align-items: center;
    font-family: var(--Font-Family-All-purpose, Poppins);
}

.button-empty-md:hover {
    background: #0027F9 !important;
    color: #fff !important;
}

.language-btn {
    width: 200px;
    border-color: #f5f5f5;
    font-family: var(--Font-Family-All-purpose, Poppins);
}

.button-empty-md, .button-yellow-md {
    min-width: 160px;
    font-family: var(--Font-Family-All-purpose, Poppins);
}

@media screen and (max-width: 1024px) {
    .button-empty-md {
        width: 100%;
    }
    .button-yellow-md {
        width: 100%;
    }
    .language-btn {
        height: 64px;
        width: 100% !important;
    }

    .login-btn {
        width: 100%;
        height: 40px;
        display: flex;
    }

    .login-btn.show {
        display: none;
    }

    .button-row {
        width: 100%;
    }
}

.language-btn > .ant-select-selector {
    color: #0B1547;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 240%; /* 33.6px */
    letter-spacing: 0.42px;
}`, "",{"version":3,"sources":["webpack://./src/css/Buttons.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wEAAwE;IACxE,+FAA+F;IAC/F,oBAAoB;IACpB,YAAY;IACZ,6FAA6F;IAC7F,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,cAAc;IACd,0DAA0D;IAC1D,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oEAAoE;IACpE,uBAAuB;IACvB,oDAAoD;AACxD;;AAEA;IACI,wEAAwE;IACxE,+FAA+F;IAC/F,0DAA0D;IAC1D,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD;AACxD;;AAEA;IACI,iEAAiE;IACjE,0DAA0D;AAC9D;;AAEA;IACI,wEAAwE;IACxE,kEAAkE;IAClE,0DAA0D;IAC1D,oDAAoD;IACpD,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,wEAAwE;IACxE,kEAAkE;IAClE,yBAAyB;IACzB,YAAY;IACZ,2DAA2D;IAC3D,uBAAuB;IACvB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,sBAAsB;AAC1B","sourcesContent":[".button {\n    display: inline-block;\n    padding: 10px 20px;\n    margin-top: 20px;\n    background-color: #007bff;\n    color: white;\n    text-decoration: none;\n    border-radius: 4px;\n}\n\n.button:hover {\n    background-color: #0056b3;\n}\n\n.button-yellow-md {\n    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;\n    background: var(--Gradient-Gradient-Yellow, linear-gradient(180deg, #FFE08B 49%, #F9C32F 100%));\n    display: inline-flex;\n    height: 72px;\n    padding: var(--Font-Size-Button-ButtonMd, 20px) var(--Space-Padding-Box-Padding-Button, 32px);\n    justify-content: center;\n    align-items: center;\n    gap: var(--Font-Size-Button-ButtonMd, 20px);\n    flex-shrink: 0;\n    color: var(--Color-Brand-Text-Default, #0B1547) !important;\n    font-size: var(--Font-Size-Button-ButtonMd, 20px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    transition: background 1s ease, color 0.3s ease, transform 0.2s ease;\n    border: none !important;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n}\n\n.button-yellow-sm-500 {\n    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;\n    background: var(--Gradient-Gradient-Yellow, linear-gradient(180deg, #FFE08B 49%, #F9C32F 100%));\n    color: var(--Color-Brand-Text-Default, #0B1547) !important;\n    font-size: var(--Font-Size-Button-ButtonMd, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    border: none !important;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n}\n\n.button-yellow-md:hover, .button-yellow-sm-500:hover {\n    background: var(--Color-Brand-Surface-Yellow, #F9C32F) !important;\n    color: var(--Color-Brand-Text-Default, #0B1547) !important;\n}\n\n.button-empty-sm-500 {\n    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;\n    border: 2px solid var(--Color-Brand-Border-Electric-Blue, #0027F9);\n    color: var(--Color-Brand-Text-Default, #0027F9) !important;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Small-Nav, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n}\n\n.button-empty-sm-500:hover {\n    background: #0027F9 !important;\n    color: #fff !important;\n}\n\n.button-empty-md {\n    border-radius: var(--Radius-Button-Pill-shaped-Button, 100px) !important;\n    border: 2px solid var(--Color-Brand-Border-Electric-Blue, #0027F9);\n    color: #0027F9 !important;\n    height: 72px;\n    padding: 20px var(--Space-Padding-Box-Padding-Button, 32px);\n    justify-content: center;\n    align-items: center;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n}\n\n.button-empty-md:hover {\n    background: #0027F9 !important;\n    color: #fff !important;\n}\n\n.language-btn {\n    width: 200px;\n    border-color: #f5f5f5;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n}\n\n.button-empty-md, .button-yellow-md {\n    min-width: 160px;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n}\n\n@media screen and (max-width: 1024px) {\n    .button-empty-md {\n        width: 100%;\n    }\n    .button-yellow-md {\n        width: 100%;\n    }\n    .language-btn {\n        height: 64px;\n        width: 100% !important;\n    }\n\n    .login-btn {\n        width: 100%;\n        height: 40px;\n        display: flex;\n    }\n\n    .login-btn.show {\n        display: none;\n    }\n\n    .button-row {\n        width: 100%;\n    }\n}\n\n.language-btn > .ant-select-selector {\n    color: #0B1547;\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 240%; /* 33.6px */\n    letter-spacing: 0.42px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
